import { render } from "./TankManagement.vue?vue&type=template&id=967c368c"
import script from "./TankManagement.vue?vue&type=script&lang=js"
export * from "./TankManagement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/display-measurement-prd-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__